<template>
  <div v-if="$featureFlags.isEnabled('meetings-inbox-gcal-integration')" class="include-line-manager">
    <div class="include-line-manager-controls">
      <k-toggle
        class="include-line-manager-toggle"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        :round="true"
        label="Include Line Manager"
        size="small"
        :disabled="!hasLineManager"
      ></k-toggle>
      <span v-if="!hasLineManager" class="include-line-manager-message">
        <i class="fas fa-exclamation-triangle"></i> Learner has no Line Manager
      </span>
    </div>
  </div>
</template>

<style scoped>
.include-line-manager {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.include-line-manager-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  align-self: flex-end;
}

.include-line-manager-controls :deep(.k-toggle) {
  margin-bottom: 0;
  min-height: 21px;
}

.include-line-manager-message {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 85%;
  color: var(--kate-type-light);
}
</style>

<script>
import KToggle from '@base-components/forms/k-toggle.vue';
import isValidLineManager from '../utils/line-manager-utils';

export default {
  name: 'include-line-manager-toggle',

  components: {
    KToggle,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    lineManager: {
      type: Object,
      default: null,
    },
  },

  emits: ['update:modelValue'],

  watch: {
    hasLineManager(hasLineManager) {
      if (!hasLineManager && this.modelValue) {
        this.$emit('update:modelValue', false);
      }
    },
  },

  computed: {
    hasLineManager() {
      return isValidLineManager(this.lineManager);
    },
  },
};
</script>
